import { useLayoutEffect } from "react";
import { trackPageView } from "../services/analytics";

// useLayoutEffect: a title és a page_view ugyanabban a tick-ben, a fizikai
// festés előtt fut le, így nincs verseny a böngésző history API-jával.
export function usePageTracking(title: string | null, pagePath: string): void {
  useLayoutEffect(() => {
    if (!title) return;
    document.title = title;
    trackPageView(pagePath, title);
  }, [title, pagePath]);
}
